import { z } from "zod";
import { Uuid,success } from "@secretaa/http-contract";
/** Historical maintenance inventory, not a user permission grant or a customer-data query. */
export const Partition=z.object({customerDataRef:z.string().regex(/^[a-z][a-z0-9_-]{0,63}$/),dataRegion:z.string().regex(/^[a-z]+-[a-z]+[0-9]$/)}).strict();
export type Partition=z.infer<typeof Partition>;
export const Request=z.object({afterId:Uuid.nullable(),limit:z.number().int().min(1).max(100)}).strict();
export type Request=z.infer<typeof Request>;
export const Result=Request.extend({partition:Partition,workspaceIds:z.array(Uuid).max(100),nextAfterId:Uuid.nullable()}).strict().refine(r=>{
 const ids=r.workspaceIds.map(id=>id.toLowerCase());
 return ids.length<=r.limit && new Set(ids).size===ids.length && ids.every((id,i)=>(i===0||id>ids[i-1]!)&&(r.afterId===null||id>r.afterId.toLowerCase()))
  && r.nextAfterId===(ids.length===r.limit?r.workspaceIds.at(-1)!:null);
},"MAINTENANCE_PAGE_INVALID");
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
export const PATH="/internal/v1/maintenance/tenants";
export const CONTRACT_VERSION="1.0.0";
